import cn from 'classnames';
import { memo, type MouseEventHandler, type ReactNode } from 'react';
import { type FieldError, type Merge } from 'react-hook-form';
import * as st from './styles.module.scss';

export type FormFieldWithLabelPT = {
  label?: string;
  className?: string;
  labelWrapperClassName?: string;
  labelHelpersClassName?: string;
  children?: ReactNode;
  labelChildren?: ReactNode;
  requiredField?: boolean;
  error?: Merge<FieldError, (FieldError | undefined)[]>;
  onClick?: MouseEventHandler<HTMLFieldSetElement>;
};
export const FormFieldWithLabel = memo(
  ({
    label,
    className,
    children,
    labelChildren,
    labelWrapperClassName,
    requiredField,
    error,
    labelHelpersClassName,
    onClick,
  }: FormFieldWithLabelPT) => {
    const isRequired = requiredField || error?.type === 'optionality';
    return (
      <fieldset className={className} onClick={onClick}>
        <div className={cn(labelWrapperClassName, st.labelWrapper)}>
          <h3>
            {label}
            {error?.message && <span className={st.errorMessage}>{error.message}</span>}
            {isRequired && !error?.message && <span className={st.redStar}>*</span>}
          </h3>
          {labelChildren && (
            <div className={cn(st.labelHelpers, labelHelpersClassName)}>{labelChildren}</div>
          )}
        </div>

        {children}
      </fieldset>
    );
  }
);
